module.exports = __webpack_public_path__ + "img/ico-case.0b1c74da.svg";